import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Link, Typography } from '@mui/material';
import './ReleaseBanner.css';

const releaseBanner = {
  id: '1.0.3-dashboard',
  version: '1.0.3',
};

const getReleaseBannerStorageKey = (releaseId) => (
  `kaj-tracker-release-banner-dismissed-${releaseId}`
);

export default function ReleaseBanner() {
  const releaseBannerStorageKey = getReleaseBannerStorageKey(releaseBanner.id);
  const [isVisible, setIsVisible] = useState(
    () => localStorage.getItem(releaseBannerStorageKey) !== 'true'
  );

  const dismissBanner = () => {
    localStorage.setItem(releaseBannerStorageKey, 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Box className="release-banner" role="status" aria-label="New version released">
      <Typography variant="body2" className="release-banner-copy">
        <span className="release-banner-badge">Version {releaseBanner.version} Released</span>
        <span className="release-banner-message">
          Check out the new{' '}
        </span>
        <Link component={RouterLink} to="/dashboard" underline="hover" className="release-banner-link">
          dashboard
        </Link>
        {' '}and read the{' '}
        <Link component={RouterLink} to="/support#changelog" underline="hover" className="release-banner-link">
          changelog
        </Link>
        <span className="release-banner-message">.</span>
      </Typography>
      <IconButton
        aria-label="Dismiss new version banner"
        className="release-banner-dismiss"
        size="small"
        onClick={dismissBanner}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
